/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MstCalendarUpdateBase } from './MstCalendarUpdateBase';
import {
    MstCalendarUpdateBaseFromJSON,
    MstCalendarUpdateBaseFromJSONTyped,
    MstCalendarUpdateBaseToJSON,
    MstCalendarUpdateBaseToJSONTyped,
} from './MstCalendarUpdateBase';

/**
 * 
 * @export
 * @interface MstCalendarUpdate
 */
export interface MstCalendarUpdate {
    /**
     * 
     * @type {Array<MstCalendarUpdateBase>}
     * @memberof MstCalendarUpdate
     */
    body: Array<MstCalendarUpdateBase>;
}

/**
 * Check if a given object implements the MstCalendarUpdate interface.
 */
export function instanceOfMstCalendarUpdate(value: object): value is MstCalendarUpdate {
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function MstCalendarUpdateFromJSON(json: any): MstCalendarUpdate {
    return MstCalendarUpdateFromJSONTyped(json, false);
}

export function MstCalendarUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstCalendarUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'body': ((json['body'] as Array<any>).map(MstCalendarUpdateBaseFromJSON)),
    };
}

export function MstCalendarUpdateToJSON(json: any): MstCalendarUpdate {
    return MstCalendarUpdateToJSONTyped(json, false);
}

export function MstCalendarUpdateToJSONTyped(value?: MstCalendarUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': ((value['body'] as Array<any>).map(MstCalendarUpdateBaseToJSON)),
    };
}

